import { render, staticRenderFns } from "./DateFilter.vue?vue&type=template&id=6d8ff6ec&scoped=true"
import script from "./DateFilter.vue?vue&type=script&lang=js"
export * from "./DateFilter.vue?vue&type=script&lang=js"
import style0 from "./DateFilter.vue?vue&type=style&index=0&id=6d8ff6ec&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8ff6ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/_work/studio-admin/studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d8ff6ec')) {
      api.createRecord('6d8ff6ec', component.options)
    } else {
      api.reload('6d8ff6ec', component.options)
    }
    module.hot.accept("./DateFilter.vue?vue&type=template&id=6d8ff6ec&scoped=true", function () {
      api.rerender('6d8ff6ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/filters/DateFilter.vue"
export default component.exports